"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import type { ComponentType } from "react";
import { ToolShell } from "@/components/tools/ToolShell";
type ToolProps = {
  toolName: string;
};
const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="p-4 text-sm text-slate-500" role="status">Loading tool…</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const TOOLS: Record<string, ComponentType<ToolProps>> = {
  "case-converter": dynamic(() => import("@/components/tools/CaseConverter"), {
    loading: Loading
  }),
  "image-compressor": dynamic(() => import("@/components/tools/ImageCompressor"), {
    loading: Loading
  }),
  "pdf-merge-split": dynamic(() => import("@/components/tools/PdfMergeSplit"), {
    loading: Loading
  }),
  "qr-code-generator": dynamic(() => import("@/components/tools/QrCodeGenerator"), {
    loading: Loading
  }),
  "password-generator": dynamic(() => import("@/components/tools/PasswordGenerator"), {
    loading: Loading
  }),
  "hsb-colour-picker": dynamic(() => import("@/components/tools/ColorPicker"), {
    loading: Loading
  }),
  "hsb-color-picker": dynamic(() => import("@/components/tools/ColorPicker"), {
    loading: Loading
  }),
  "color-picker": dynamic(() => import("@/components/tools/ColorPicker"), {
    loading: Loading
  }),
  "base64-encoder": dynamic(() => import("@/components/tools/Base64Tool"), {
    loading: Loading
  }),
  "markdown-to-html": dynamic(() => import("@/components/tools/MarkdownToHtml"), {
    loading: Loading
  }),
  "image-cropper": dynamic(() => import("@/components/tools/ImageCropper"), {
    loading: Loading
  }),
  "unit-converter": dynamic(() => import("@/components/tools/UnitConverter"), {
    loading: Loading
  }),
  "fancy-text-generator": dynamic(() => import("@/components/tools/FancyTextGenerator"), {
    loading: Loading
  })
};
const WordCounter = dynamic(() => import("@/components/tools/WordCounter"), {
  loading: Loading
});
export function ToolWorkspace(t0) {
  const $ = _c(6);
  const {
    toolName,
    toolSlug
  } = t0;
  const Tool = toolSlug && TOOLS[toolSlug] || WordCounter;
  let t1;
  if ($[0] !== Tool || $[1] !== toolName) {
    t1 = <Tool toolName={toolName} />;
    $[0] = Tool;
    $[1] = toolName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1 || $[4] !== toolName) {
    t2 = <ToolShell toolName={toolName}>{t1}</ToolShell>;
    $[3] = t1;
    $[4] = toolName;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}